export default __webpack_public_path__ + "static/media/Zadie_9781408331453.4a3d4b87.jpg";